import { getBackendEnv } from 'utils/platform';

export const AWS_REGION = 'eu-west-2';

export enum S3Bucket {
  CSV = 'popp-ai-prospects-csv-bucket',
  PUBLIC = 'popp-ai-storage',
  CANDIDATE_BATCH = 'popp-ai-candidate-batch',
  CALENDAR = 'popp-ai-calendar'
}

export const getFullBucketName = (bucket: S3Bucket) =>
  `${bucket}-${getBackendEnv()}`;

export const bucketNames = Object.values(S3Bucket).map(getFullBucketName);

export const getPublicS3URL = (path: string) =>
  `https://${getFullBucketName(
    S3Bucket.PUBLIC
  )}.s3.${AWS_REGION}.amazonaws.com/${path}`;
